// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3tyN7","balanceDisclaimer":"posDashboard_balanceDisclaimer__jEgEO"};